module.exports = __webpack_public_path__ + "static/hero-bg-c0c66f7858c40cbfdbbae92baa4be725.png";